module.exports = __webpack_public_path__ + "static/media/imageGallary.445c9da5.jpg";